import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import ProductNav from '../../../common/ProductNav';
import { tabsValues } from '../../../config/pageConfig';
import Specs from '../../specs';
import Support from '../../support';
import Bundles from '../Bundles';
import ApplianceRatings from '../components/ApplianceRatings';
import BannerA from '../components/BannerA';
import FooterTcA from '../components/FooterTcA';
import IndustryLeadingA from '../components/IndustryLeadingA';
import IndustryLeadingB from '../components/IndustryLeadingB';
import IndustryLeadingC from '../components/IndustryLeadingC';
import IndustryLeadingD from '../components/IndustryLeadingD';
import IndustryLeadingE from '../components/IndustryLeadingE';
import IndustryLeadingF from '../components/IndustryLeadingF';
import PowerTechnology from '../components/PowerTechnology';
import ProductCheckList from '../components/ProductCheckList';
import ProductComparison from '../components/ProductComparison';
import SectionPicture from '../components/SectionPicture';
import UsageScenariosA from '../components/UsageScenariosA';
import UsageScenariosB from '../components/UsageScenariosB';
import UsageScenariosC from '../components/UsageScenariosC';
import UsageScenariosD from '../components/UsageScenariosD';
import UsedDuringDisasters from '../components/UsedDuringDisasters';
import SingleItemCard from '../components/SingleItemCard';
import PageNavLeft from '../components/PageNavLeft';
import { useLang } from '@/i18n';

export default function StatusItem() {
    const { query } = useRouter();
    const searchTab = query?.tab;
    const IndustryLeadingEREF = useRef();
    const { t } = useLang('Delta3MaxSeriesStation');
    let defaultTab = 'Product';
    if (typeof searchTab === 'string' && tabsValues.includes(searchTab)) {
        defaultTab = searchTab;
    }
    const [activeTab, setActiveTab] = useState(defaultTab);
    const tabCallback = (tabValue: string) => {
        setActiveTab(tabValue);
    };

    const linkClick = (index: any) => {
        IndustryLeadingEREF.current?.changeTwoItem(index);
    };
    return (
        <>
            <ProductNav activeTab={activeTab} tabCallback={tabCallback} />
            {activeTab === 'Product' && (
                <div className="Product">
                    <BannerA />
                    <SectionPicture linkClick={linkClick} />
                    <SingleItemCard />
                    {/* <FixProcess /> */}
                    <UsageScenariosA />
                    <IndustryLeadingA />
                    <UsageScenariosB />
                    <IndustryLeadingB />
                    <UsageScenariosC />
                    <IndustryLeadingC />
                    <IndustryLeadingD />
                    <UsageScenariosD />
                    <IndustryLeadingE ref={IndustryLeadingEREF} />
                    <IndustryLeadingF />
                    <PowerTechnology />
                    <ProductComparison />
                    <ApplianceRatings />
                    <UsedDuringDisasters />
                    <ProductCheckList />
                    <FooterTcA />
                    <PageNavLeft
                        triggerElement=".delta-3-max-series .Product"
                        enterElement="#SingleItemCard"
                        steps={[
                            { text: t('FixProcess.KSP-1'), href: '#UsageScenariosA' },
                            { text: t('FixProcess.KSP-2'), href: '#UsageScenariosB' },
                            { text: t('FixProcess.KSP-3'), href: '#UsageScenariosC' },
                            { text: t('FixProcess.KSP-4'), href: '#IndustryLeadingD' },
                            { text: t('FixProcess.KSP-5'), href: '#UsageScenariosD' },
                            { text: t('FixProcess.KSP-6'), href: '#IndustryLeadingF' },
                            { text: t('FixProcess.KSP-7'), href: '#PowerTechnology' },
                        ]}
                    />
                </div>
            )}
            {activeTab === 'Specs' && (
                <>
                    <Specs />
                </>
            )}
            {activeTab === 'Support' && (
                <>
                    <Support />
                </>
            )}
            {activeTab === 'Bundles' && (
                <>
                    <Bundles />
                    <FooterTcA />
                </>
            )}
        </>
    );
}
